import {
  AppointmentsByPersonRecordDto,
  AppointmentsByPersonRecordDtoV2,
  CreateAppointmentDtoV2,
} from 'src/api/generated'
import { ENDPOINTS_TAGS, rootApi } from 'src/v2/store/api/rootApi'

import { IUpdateAppointment } from '../appointment.type'

export const appointmentApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getPersonAppointmentsV1: builder.query<
      AppointmentsByPersonRecordDto[],
      string
    >({
      query: (personId) => ({
        url: `/appointments/person/${personId}`,
        method: 'GET',
      }),
      providesTags: [ENDPOINTS_TAGS.APPOINTMENTS],
    }),
    createAppointmentV1: builder.mutation<
      AppointmentsByPersonRecordDto,
      CreateAppointmentDtoV2
    >({
      query: (data) => ({
        url: 'v2/appointments',
        method: 'POST',
        data,
      }),
      invalidatesTags: [ENDPOINTS_TAGS.APPOINTMENTS],
    }),
    updateAppointmentV1: builder.mutation<
      AppointmentsByPersonRecordDto,
      IUpdateAppointment
    >({
      query: (data) => {
        const { id, ...updateData } = data
        return {
          url: `v2/appointments/${id}`,
          method: 'PUT',
          data: updateData,
        }
      },
      invalidatesTags: [ENDPOINTS_TAGS.APPOINTMENTS],
    }),
  }),
})

export const {
  useGetPersonAppointmentsV1Query,
  useCreateAppointmentV1Mutation,
  useUpdateAppointmentV1Mutation,
} = appointmentApi
